import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "q-px-sm" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../../store/useUserStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'FormEndOfDay',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["continueToLegal", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const applyTravelOverrideRule = ref(false)

const user = storeToRefs(useUserStore())

const labelKey = computed(() => {
  switch (user.country_id.value) {
    case 2: //can
      return 'travelOverrideCan'
    case 1: //us + others
    default:
      return 'travelOverride'
  }
})

const emitContinue = () => emit('continueToLegal', applyTravelOverrideRule.value)

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(label('endOfDay')), 1)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(label('endOfDayInfo')) + " ", 1),
      _createElementVNode("div", null, [
        _createVNode(_component_q_checkbox, {
          modelValue: applyTravelOverrideRule.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((applyTravelOverrideRule).value = $event)),
          label: label(labelKey.value)
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    actions: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_btn, {
        rounded: "",
        flat: "",
        label: label('close')
      }, null, 8, ["label"]), [
        [_directive_close_popup]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
        rounded: "",
        color: "primary",
        onClick: emitContinue
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(label('continue')), 1)
        ]),
        _: 1
      })), [
        [_directive_close_popup]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})